import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Footer from '../../components/Footer';
import InputField from '../../components/InputField';
import CalculationResultPart from '../../components/CalculationResultPart';
import { Helmet } from "react-helmet-async";
import { Link } from 'react-router-dom';
import { ASKERLIK_ASGARI, ASKERLIK_TABAN_KATSAYISI, ASKERLIK_TAVAN_KATSAYISI } from '../../constants/constants';
import Header from '../../components/Header';

const faqs = [
    {
        question: "Askerlik borçlanması, sigortalı çalışanların veya hak sahiplerinin, er veya erbaş olarak silah altında veya Yedek Subay Okulu'nda geçen sürelerini borçlanarak emeklilik haklarını iyileştirmelerine imkan tanıyan bir uygulamadır.",
    },
    {
        question: "<h5>Askerlik Borçlanmasının Faydaları:</h5>",
        answer: ["Sigortalılık başlangıç tarihini öne çeker.", "Emeklilik için gerekli prim gün sayısını artırır.", "Emeklilik aylığının miktarını yükseltir."],
    },
    {
        question: "<h5>Askerlik Borçlanması Hesaplama:</h5>",
        answer: ["Borçlanma, günlük kazancın %32'si üzerinden hesaplanır.", "Günlük kazanç, prime esas günlük kazanç alt ve üst sınırları arasında belirlenebilir."],
    },
    {
        question: "<h5>Askerlik Süresinin Bir Kısmı Borçlanabilir mi?</h5>",
        answer: ["Evet, askerlik süresinin tamamı veya bir kısmı borçlanabilir."],
    },
    {
        question: "<h5>Birden Fazla Kez Borçlanma Mümkün mü?</h5>",
        answer: ["Evet, daha önce borçlanılan süre dışında kalan süreler için tekrar borçlanma yapılabilir."],
    },
    {
        question: "<h5>Askerlik Borçlanması Nasıl Yapılır?</h5>",
        answer: ["Askerlik Borçlanma Belgesi doldurulur.", "Belge, bağlı olunan Sosyal Güvenlik İl Müdürlüğü veya Merkezi'nde tasdik edilir.", "Belge ve hesaplanan tutar ile Sosyal Güvenlik İl Müdürlüğü veya Merkezi'ne başvurulur."],
    },
    {
        question: "<h5>Primler Ne Zaman Ödenmeli?</h5>",
        answer: ["Primler, tebliğ tarihinden itibaren bir ay içinde ödenir.", "Ödenmeyen primler için yeniden başvuru yapılabilir."],
    },
    {
        question: "<h5>Ödenen Primler Geri Alınabilir mi?</h5>",
        answer: ["Hayır, borçlanma nedeniyle ödediğiniz primleri geri alamazsınız."],
    },
    {
        question: "<h5>Askerlik Borçlanması Emeklilikte Son Yedi Yıla Katılır mı?</h5>",
        answer: ["Hayır, borçlanma yapılan süre emeklilikte son yedi yılın hesabına katılmaz."],
    },
    {
        question: "<h5>01.10.2008 Tarihinden Önce Memur Olanların Askerlik Borçlanması:</h5>",
        answer: ["Bu tarihte önce memur olanlar, borçlanmalarını 5434 sayılı Emekli Sandığı Kanunu'na tabi olarak yaparlar."],
    },
    {
        question: "<h5>Askerlik borçlanması ile ilgili daha detaylı bilgi için:</h5>",
        answer: ["Sosyal Güvenlik Kurumu'nun internet sitesini ziyaret edebilirsiniz.", "Sosyal Güvenlik İl Müdürlüğü veya Merkezi'ne başvurabilirsiniz.", "Bir avukata danışabilirsiniz."],
    },
];

const AskerlikBorclanmasiHesaplama = () => {
    const [hideAll, setHideAll] = useState(false);
    const [results, setResults] = useState([]);
    const [calculated, setCalculated] = useState(false);
    const [gunSayisi, setGunSayisi] = useState(null);

    const location = useLocation();
    const navigate = useNavigate();
    
	useEffect(() => {
		const query = new URLSearchParams(location.search);

		if (query.toString()) {
			const parsedResults = query.get('results');
			if (parsedResults) {
				setResults(JSON.parse(decodeURIComponent(atob(parsedResults))));
			}

			setGunSayisi(Number(decodeURIComponent(atob(query.get('gun_sayisi')))));
            setCalculated(true);
		}
		
		localStorage.setItem('referrer', `${window.location.origin}${window.location.pathname}`);
	}, [location.search]);

	const calculate = () => {
		if (gunSayisi) {
			setHideAll(true);

            const gunluk_asgari = ASKERLIK_ASGARI / 30;
            const gunluk_taban = gunluk_asgari * ASKERLIK_TABAN_KATSAYISI;
            const gunluk_tavan = gunluk_taban * ASKERLIK_TAVAN_KATSAYISI;

			const newResults = [
				{ text: "Borçlanma Taban Tutarı", value: gunluk_taban * gunSayisi },
				{ text: "Borçlanma Tavan Tutarı", value: gunluk_tavan * gunSayisi },
			];

			setResults(newResults);

			const params = new URLSearchParams({
				results: btoa(encodeURIComponent(JSON.stringify(newResults))),
				gun_sayisi: btoa(encodeURIComponent(gunSayisi.toString())),
			});

			navigate(`${window.location.pathname}?${params.toString()}`);
			navigate(0);
		} else {
			alert("Lütfen tüm değerleri doğru girdiğinizden emin olunuz!");
		}
	};

    return (
        <>
            <Helmet>
                <title>Askerlik Borçlanması Hesaplama - Legalbul</title>
                <link rel="canonical" href={`${window.location.origin}${window.location.pathname}`} />
                <meta name="description" content="Askerlik borçlanması, sigortalı çalışanların askerlikte geçen sürelerini borçlanarak emeklilik haklarını artırmalarına olanak sağlayan bir uygulamadır." />
            </Helmet>
            
            <Header />
            <section className="container my-5 bg-white shadow-sm p-0">
                <div className="p-4">
                    <ol className="breadcrumbnav">
                        <li>
                            <Link to="/">Ana Sayfa</Link>
                        </li>
                        <li>
                            <Link to="/hesaplamalar">Tüm Hesaplamalar</Link>
                        </li>
                        <li>
                            Askerlik Borçlanması Hesapla
                        </li>
                    </ol>
                    <h1 className="fw-semibold">Askerlik Borçlanması Hesaplama</h1>
                    <p>Askerlik borçlanması, sigortalı çalışanların askerlikte geçen sürelerini borçlanarak emeklilik haklarını artırmalarına olanak sağlayan bir uygulamadır.</p>

                    <InputField value={gunSayisi} setValue={setGunSayisi} trailText="gün" label="Gün Sayısı" type="number" />
                </div>

                <CalculationResultPart calculated={calculated} hideAll={hideAll} results={results} calculate={calculate} />
            </section>
            
            <Footer faqs={faqs} faqTitle="Askerlik Borçlanması Hakkında Bilmeniz Gerekenler" />
        </>
    );
};

export default React.memo(AskerlikBorclanmasiHesaplama);
